import { styled } from '@mui/material/styles';

export const Container = styled('div')({
  padding: '30px',
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  overflow: 'auto',
});

export const SectionTitle = styled('h1')({
  fontSize: '1.8rem',
  marginBottom: '0.5rem',
  fontWeight: 500,
  color: '#333',
});

export const SettingsSection = styled('div')({
  backgroundColor: '#fff',
  borderRadius: '8px',
  padding: '25px',
  marginBottom: '30px',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
});

export const SectionHeader = styled('h2')({
  fontSize: '1.3rem',
  marginBottom: '20px',
  fontWeight: 500,
  color: '#333',
});

export const SettingsGrid = styled('div')({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '20px',
  
  '@media (max-width: 768px)': {
    gridTemplateColumns: '1fr',
  },
});

export const SettingItem = styled('div')({
  marginBottom: '20px',
});

export const SettingLabel = styled('label')({
  display: 'block',
  marginBottom: '8px',
  fontSize: '0.9rem',
  fontWeight: 500,
});

export const SettingDescription = styled('p')({
  fontSize: '0.85rem',
  color: 'rgba(0, 0, 0, 0.6)',
  margin: '5px 0 0 0',
});

export const ActionButtons = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '15px',
  marginTop: '20px',
});